import { createSelector } from "reselect";
import { patientsSectionSelector } from "../patients_section_selector";

export const checkedLocationIdsSelector = createSelector(
  patientsSectionSelector,
  patientsSection => {
    return patientsSection.checkedLocationIds;
  }
);
